const locale = {
  submit: 'Submit',
  cancel: 'Cancel',
  complete: 'Complete',
  next: 'Next',
  addText: 'Add',
  deleteText: 'Delete'
};

export default locale;
